package com.daytimegaming.ourdailyfinances.data.network

import com.daytimegaming.ourdailyfinances.BuildKonfig
import com.daytimegaming.ourdailyfinances.domain.repository.AuthRepository
import com.daytimegaming.ourdailyfinances.data.settings.SettingsManager
import io.ktor.client.HttpClient
import io.ktor.client.engine.HttpClientEngine
import io.ktor.client.plugins.auth.Auth
import io.ktor.client.plugins.auth.providers.BearerTokens
import io.ktor.client.plugins.auth.providers.bearer
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.DEFAULT
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging
import io.ktor.client.plugins.HttpResponseValidator
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlinx.serialization.json.jsonArray

import com.daytimegaming.ourdailyfinances.getPlatform

class ApiClient(
    engine: HttpClientEngine,
    private val authRepository: AuthRepository,
    private val settingsManager: SettingsManager,
    enableLogging: Boolean = false,
) {
    val baseUrl: String
        get() = if (getPlatform().name == "Web Browser") {
            if (settingsManager.isStaging()) "/staging-api" else "/api"
        } else {
            if (settingsManager.isStaging()) {
                BuildKonfig.STAGING_API_URL
            } else {
                BuildKonfig.API_URL
            }
        }

    val http: HttpClient = HttpClient(engine) {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                isLenient = true
            }, contentType = ContentType.Any)
        }
        install(Auth) {
            bearer {
                loadTokens {
                    BearerTokens(authRepository.getIdToken(), "")
                }
                refreshTokens {
                    BearerTokens(authRepository.getIdToken(forceRefresh = true), "")
                }
            }
        }
        install(Logging) {
            logger = Logger.DEFAULT
            level = if (enableLogging || settingsManager.isDebug()) LogLevel.ALL else LogLevel.NONE
        }
        HttpResponseValidator {
            validateResponse { response ->
                val statusCode = response.status.value
                if (statusCode >= 400) {
                    val message = parseErrorDetail(response)
                    throw ApiException(message, statusCode)
                }
            }
        }
    }
}

class ApiException(message: String, val statusCode: Int) : Exception(message)

private suspend fun parseErrorDetail(response: HttpResponse): String {
    return try {
        val text = response.bodyAsText()
        val jsonElement = Json.parseToJsonElement(text)
        val detail = jsonElement.jsonObject["detail"]
        if (detail != null) {
            if (detail is kotlinx.serialization.json.JsonPrimitive) {
                detail.jsonPrimitive.content
            } else if (detail is kotlinx.serialization.json.JsonArray) {
                detail.jsonArray.mapNotNull {
                    try {
                        val obj = it.jsonObject
                        val msg = obj["msg"]?.jsonPrimitive?.content
                        val loc = obj["loc"]?.jsonArray?.map { l -> l.jsonPrimitive.content }?.joinToString(".")
                        if (loc != null && msg != null) "$loc: $msg" else msg
                    } catch (e: Exception) {
                        null
                    }
                }.joinToString("; ")
            } else {
                detail.toString()
            }
        } else {
            "HTTP error ${response.status.value}"
        }
    } catch (e: Exception) {
        "HTTP error ${response.status.value}"
    }
}

